import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { CargoService } from 'src/app/services/cargo.service';
import { PreCandidatosService } from 'src/app/services/precandidatos.service';
import { Utils } from 'src/app/utils/utils';

@Component({
  selector: 'app-lista-candidaturas',
  templateUrl: './lista-candidaturas.component.html',
  styleUrls: ['./lista-candidaturas.component.css']
})
export class ListaCandidaturasComponent implements OnInit {

  idEleicao: any;
  idAprovador: any;
  idCargo: any;
  cargo: any;
  preCandidatos: any;
  candidatura:any;
  token: string;

  constructor(
    protected router: Router,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private cargoService: CargoService,
    protected messageService: MessageService,
    public utils: Utils
    ) {
      this.idEleicao = +this.route.snapshot.params.idEleicao;
      this.idAprovador = +this.route.snapshot.params.idAprovador;
      this.idCargo = +this.route.snapshot.params.idCargo;
    }

  ngOnInit() {
    this.spinner.hide();
    this.token = sessionStorage.getItem('token');
    this.idCargo = sessionStorage.getItem('idCargo');
    this.idAprovador = sessionStorage.getItem('idAprovador');
    this.buscarCargo(this.idCargo);
  }

  buscarCargo(idCargo){
    this.cargoService.getByIdCargo(idCargo, this.token).then((data: any) => {
      this.cargo = data;
    });
  }

  voltar(){
    this.router.navigate(['../lista-cargos'], {relativeTo: this.route});
  }

}


